import { useEffect, useRef, useState } from "react"
import { createPortal } from "react-dom"
import styles from "./modal.module.css"

interface ModalProps {
  open: boolean,
  onOpenChange: (open: boolean) => void,
  design: 'modal' | 'overlay',
  children: React.ReactNode
}

export function Modal({ open, onOpenChange, design, children }: ModalProps) {
  const overlay = useRef<HTMLDivElement>(null)
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
    return () => setMounted(false)
  }, [])

  if (!mounted || !open) return null

return createPortal(
    <div // NOSONAR
      className={design === 'modal' ? styles.modalBackground : styles.overlayBackground}
      ref={overlay}
      onClick={(e) => {
        if (e.target === overlay.current) onOpenChange(false)
      }}
      tabIndex={-1}
      onKeyDown={(e) => {
        if (e.key === 'Escape') {
          e.preventDefault()
          onOpenChange(false)
        }
      }}
    >
      <div  // NOSONAR
        className={design === 'modal' ? styles.modalContent : styles.overlayContent} 
        role="dialog"
        aria-modal="true"
      >
        {design === 'modal' &&(
          <button 
            type="button"
            className={styles.closeButton} 
            onClick={() => {
              onOpenChange(false);
            }}
            aria-label="Close"
          >
            ✕
          </button>
        )}
        {children}
      </div>
    </div>,
    document.body,
  )
}

